export default __webpack_public_path__ + "static/media/9fdr.9b969b34.webp";